module.exports = __webpack_public_path__ + "static/media/hourglass.d79218d1.gif";